<template>
  <div class="image" :style="inputBG">
    <div class="image">
      <img class="pic" :src="src" :style="picStyle" />
    </div>
    <div class="desc" :style="descStyle">{{desc}}</div>
  </div>
</template>

<script>
 export default {
   name: 'MyImage',
   props: ['src', 'width', 'desc', 'inputBG', 'descStyle', 'picStyle'],
   computed: {
     inputStyle () {
       return {
         margin: '0.2vw',
         width: this.width
       }
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .image{
   text-align: center;
 }
 .desc {
   color: white;
   font-size: 1.1vw;
   margin-top: 1.6vw;
 }
 .pic{
   margin: 0.2vw;
   max-width: 12.3vw;
   max-height: 6.98vw;
 }

@media (min-width: 320px) and (max-width: 480px) {
  .desc{
  font-size: 1.6vw;
  }
  .pic{
    max-width: 18vw;
    max-height:  10.21vw;
  }
 }
</style>
